import { Box, Typography,InputAdornment, FormControl, MenuItem, TextField} from '@mui/material'
import React, { useEffect, useState } from 'react'
import TranscriberAndAudio from '../../components/AssistantForms/TranscriberAndAudio';
import AdditionalConfigurations from '../../components/AssistantForms/AdditionalConfigurations';
import AssistantOverview from '../../components/AssistantOverview';
import { CheckCircleOutline, DashboardOutlined, DescriptionOutlined, RecordVoiceOverOutlined, SettingsOutlined } from '@mui/icons-material';
import NewPrompt from '../../components/AssistantForms/NewPrompt';
import NewActions from '../../components/AssistantForms/NewAction';
import { useGetAllPermissions } from '../utils/getAllPermissions';
import { FilterList } from '@mui/icons-material';
import { textFieldSx } from '../../styles/GlobalStyles';
const ViewAssistant = ({ assistant, actions }) => {
    const [ token, setToken ] = useState('');
    const { permissions, getAllPermissions } = useGetAllPermissions();
    const [ currentTab, setCurrentTab ] = useState(0);
    const [filter, setFilter] = useState("monthly");

    useEffect(() => {
        getAllPermissions();
    }, [token, getAllPermissions]);
    
    const handleFilterChange = (event) => {
        setFilter(event.target.value);
        console.log("filter",filter)
    };
  
    const setLocalStorageValues = () => {
        const localAssistant = {
            Prompt: assistant.Prompt || "",
            InitialMsg: assistant.InitialMsg || "",
            AssistantGoal: assistant.AssistantGoal || "",
            LLMProvider: assistant.LLMProvider?._id || "",
            LLMModel: assistant.LLMModel?._id || "",
            MaxToken: assistant.MaxToken || "",
            Temperature: assistant.Temperature || "",
            TranscriberProvider: assistant.TranscriberProvider?._id || "",
            Transcriber: assistant.Transcriber?._id || "",
            TranscriberLanguage: assistant.TranscriberLanguage?._id || "",
            VoiceProvider: assistant.VoiceProvider?._id || "",
            Voice: assistant.Voice?._id || "",
            VoiceLanguage: assistant.VoiceLanguage?._id || "",
            SpeedOfText: assistant.SpeedOfText || "",
            Interruption: assistant.Interruption || "",
            Cutoff: assistant.Cutoff || "",
            IdealTime: assistant.IdealTime || "",
            CallEndText: assistant.CallEndText || "",
            CallEndFlag: assistant.CallEndFlag || 0,
            TransferPhoneNumber: assistant.TransferPhoneNumber || "",
            EndConversationOnTransfer: assistant.EndConversationOnTransfer || 0,
            EndConversationOnGoodbye: assistant.EndConversationOnGoodbye || 0,
            NumOfHumanCheck: assistant.NumOfHumanCheck || 1,
            FilterAudio: assistant.FilterAudio || 0,
            InitialMsgDelay: assistant.InitialMsgDelay || "",
            CutOffResponse: assistant.CutOffResponse || "",
            _id: assistant._id
        };
        const localKnowledgebase = {
            name: assistant?.KnowledgeBase?.fileUrl || "",
            size: assistant?.KnowledgeBase?.fileSize || ""
        }

        // Store the assistant object
        localStorage.setItem('assistant', JSON.stringify(localAssistant));
        localStorage.setItem('KnowledgeBase', JSON.stringify(localKnowledgebase));

        // Store actions if they exist and are an array
        if (Array.isArray(actions) && actions.length > 0) {
            localStorage.setItem('actions', JSON.stringify(actions));
        } else {
            localStorage.removeItem('actions');
        }
    };

    const getToken = () => {
        const t = JSON.parse(localStorage.getItem('token')).token
        setToken(t)
    }
   
    
    useEffect(() => {
        getToken();
        setLocalStorageValues();
    }, [ assistant, token ])
    
    const handleTabChange = (newValue) => {
        setCurrentTab(newValue);
    };

    const tabs = [
        { label: "Overview", icon: <DashboardOutlined sx={{ fontSize: 20 }} /> },
        { label: "Prompt", icon: <DescriptionOutlined sx={{ fontSize: 20 }} /> },
        { label: "Transcriber and Voice", icon: <RecordVoiceOverOutlined sx={{ fontSize: 20 }} /> },
        { label: "Configurations", icon: <SettingsOutlined sx={{ fontSize: 20 }} /> },
        ...(
            permissions?.some(p => ["fetch_actions", "create_action", "update_action", "delete_action"].includes(p)) 
            ? [{ label: "Actions", icon: <CheckCircleOutline sx={{ fontSize: 20 }} /> }] 
            : []
        )
    ];

    return (
        <>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb:"1rem", mt:"1rem" }}>
                <Box sx={{ display: "flex", backgroundColor: "#FFFFFF", border: '1px solid #E5E7EB', borderRadius: "12px", px:"0.5rem",py:"0.5rem", gap: "0.5rem",mt:"0.5rem",mb:"0.5rem" }}>
                    {tabs.map((tab, index) => (
                        <Typography
                            key={index}
                            onClick={() => handleTabChange(index)}
                            sx={{
                                cursor: "pointer",
                                padding: "0.5rem 1rem",
                                borderRadius: currentTab === index ? "4px" : "8px",
                                fontWeight: 500,
                                backgroundColor: currentTab === index ? "#02042D" : "transparent",
                                color: currentTab === index ? "white" : "black",
                                transition: "all 0.2s ease",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                '&:hover': {
                                    backgroundColor: currentTab === index ? "#02042D" : "#EDEDED",
                                    color: currentTab === index ? "white" : "black",
                                    borderRadius: "4px",
                                }
                            }}
                        >
                            {tab.icon}
                            {tab.label}
                        </Typography>
                    ))}
                </Box>
                { currentTab === 0 &&
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "auto",
                }}>
                <FormControl sx={{ minWidth: 180}}>
                <TextField
                    value={filter}
                    onChange={handleFilterChange}
                    sx={textFieldSx}
                    label="Filter"
                    select
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <FilterList />
                            </InputAdornment>
                        ),
                    }}
                >
                         <MenuItem value="All">All</MenuItem>
                            <MenuItem value="weekly">Weekly</MenuItem>
                            <MenuItem value="monthly">Monthly</MenuItem>
                            <MenuItem value="yearly">Yearly</MenuItem>
                    </TextField>
                    </FormControl>
                </Box>
                }
            </Box>
           {/* Tabs Section */}
           
            <Box>
                {
                    currentTab === 0 &&
                    <AssistantOverview filter={filter} />
                }
                {
                    currentTab === 1 && <NewPrompt assistantId={assistant._id} />
                }
                {
                    currentTab === 2 && <TranscriberAndAudio />
                }                                               
                {
                    currentTab === 3 && <AdditionalConfigurations />
                }
                {
                    currentTab === 4 && <NewActions />
                }
            </Box>
       </>
    )
}

export default ViewAssistant;
